module.exports = __webpack_public_path__ + "img/img-text-2.608ad6c2.png";